// @flow
import * as React from 'react';
import { useContext } from 'react';
import { Redirect } from 'react-router-dom';
import SearchView from 'containers/search';
import { networkSearch } from 'api/content/search';
import SyndicationCopy from './NetworkSearchCopy';
import { NetworkQuestionFieldsets } from './SearchForm/config/forms.config';
import { ClientContext } from 'containers/client/ClientProvider';
import { getIsPwrDistroClient } from 'components/ModerationCard/ClientModerationCard/utils';

const { primaryFieldsets } = NetworkQuestionFieldsets;

const label = 'Network Questions';
export default function NetworkQuestions(props: *) {
  const clientProps = useContext(ClientContext);

  if (clientProps && getIsPwrDistroClient(clientProps.clientId, clientProps)) {
    const { location } = props;
    const newPathname = location.pathname.replace(
      '/network-questions',
      '/questions-search'
    );
    return <Redirect to={{ pathname: newPathname, search: location.search }} />;
  }

  const { hideCopy, ...rest } = props;

  return (
    <SearchView
      label={label}
      primaryFieldsets={primaryFieldsets}
      method={networkSearch}
      copy={hideCopy ? null : <SyndicationCopy />}
      {...rest}
    />
  );
}

NetworkQuestions.label = label;



// WEBPACK FOOTER //
// ./src/containers/search/NetworkQuestions.js